import { useTranslation } from "react-i18next";

const DashboardBar = () => {
    const { t } = useTranslation();

    return (
        <div>
            <h1>
                <span>{t(`General##dashboard`)}</span>
            </h1>
        </div>
    );
};

export default DashboardBar;
